import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { ServicesContext } from 'services/context'

import BinaryBetFormComponent from './component'

const { any } = validators

export const BinaryBetForm = combine(
  withContext(
    'adminTournamentService',
    ServicesContext,
    ({ adminTournamentService }) => adminTournamentService
  ),
  withCallbacks(
    {
      changeInwinnable:
        ({ adminTournamentService }, { initialValues, onInWinnableProxy }) =>
        async (status) => {
          const content = await adminTournamentService.inwinnableMatch(
            initialValues.id,
            status
          )
          onInWinnableProxy()
          return content
        },
    },
    []
  ),
  withFormModel(
    (_state, { initialValues }) => ({
      eventId: {
        initialValue: initialValues.id,
        spec: spec.flow(any.required),
      },

      isBlockInWins: {
        initialValue: initialValues.inWinnable,
        spec: spec.flow(any.required),
      },

      binaryWinner: {
        alias: 'Favourite',
        spec: spec.flow(any.required),
      },
    }),
    { id: 'binary-bet-form' }
  )
)(BinaryBetFormComponent)
